import { configureStore } from '@reduxjs/toolkit';
// import { persistStore, persistReducer } from "redux-persist";
// import storage from "redux-persist/lib/storage";

import ableReducer from './ableReducer';
import demoReducer from './demoReducer';
import authReducer from '../Pages/Login/LoginSlice';
import commonReducer from './reducers/common';
import subscriptionReducer from './reducers/subscription';
import profileReducer from './reducers/profile';
import invoiceReducer from './reducers/invoice';
import dashboardReducer from './reducers/dashboard';
import paymentReducer from './reducers/payment';
import supportReducer from './reducers/support';
import { localStorageMiddleware } from './middleware';
import speedboostpromoReducer from './reducers/speedboostpromo';
import discourseReducer from './reducers/discourse';
import pendingsubscriptionReducer from './reducers/pendingsubscription';
import pendingupdatedetailsReducer from './reducers/pendingupdatedetails';
import supportticketReducer from './reducers/supportticket';
import securenetdashboardReducer from './reducers/securenetdashboard';
import pageLoaderReducer from "./reducers/pageLoader";
import recontractReducer  from "./reducers/recontractlog";
import reloadReducer   from "./reducers/reloadSlice";

import invalidEmailReducer from "./reducers/invalidEmail"; 
import altPostalCodeReducer  from "./reducers/altpostalcode"; 
import rescheduleDeliveryReducer from "./reducers/rescheduledelivery";
import notificationLinkLossReducer   from "./reducers/notificationlinkloss";
import deliveryDatesReducer from "./reducers/deliverydates";



// const persistConfig = {
//   key: "root",
//   storage,
// };

// const persistedReducer = persistReducer(persistConfig, pendingsubscriptionReducer);

export function makeStore(preloadedState) {
  return configureStore({
    reducer: {
      auth: authReducer,
      able: ableReducer,
      demo: demoReducer,
      common: commonReducer,
      subscription: subscriptionReducer,
      profile: profileReducer,
      invoice: invoiceReducer,
      dashboard: dashboardReducer,
      payment: paymentReducer,
      support: supportReducer,
      speedboostpromo: speedboostpromoReducer,
      discourse: discourseReducer,
      pendingsubscriptions: pendingsubscriptionReducer,
      pendingupdatedetails: pendingupdatedetailsReducer,
      supportticket: supportticketReducer,
      securenetdashboard: securenetdashboardReducer,
      pageLoader: pageLoaderReducer,
      recontract: recontractReducer,
      reload: reloadReducer,
      invalidEmail: invalidEmailReducer,
      rescheduleDelivery: rescheduleDeliveryReducer,
      notificationLinkLoss: notificationLinkLossReducer,
      deliveryDates: deliveryDatesReducer,
      altPostalCode: altPostalCodeReducer,
      rescheduleDelivery: rescheduleDeliveryReducer,
      notificationLinkLoss: notificationLinkLossReducer
    },
    devTools: true,
    preloadedState,
    middleware: (getDefaultMiddleware) => [
      ...getDefaultMiddleware(),
      localStorageMiddleware,
    ],
  });
}

const store = makeStore();

export default store;
